export default __webpack_public_path__ + "static/pes-16cfab11b6e61fba561f923a337f3261.jpg";